import { ApplicationMainModel, ApplicationMainModelFile, ApplicationMainModelFileTypeEnum, GetApplicationMainModelDocument, LanguagesEnum } from "../../../generated/graphql";
import { BundleMode, BundleNames, invalidFileExtensions, maxImageSize, maxTitleSymbols, requiredFields, validImageTypes } from "./constants";
import { mobileAppModel } from "./state";
import { coordsCheckHandler } from "../../shared/Utils/CheckOperations/coordsCheckHandler";

export const currentBundleFindHandler = (
  bundles: ApplicationMainModelFile[],
  type: ApplicationMainModelFileTypeEnum,
  language: LanguagesEnum
): ApplicationMainModelFile => {
  return bundles.find(
    (bundle) => bundle.type === type && (bundle.language as unknown as LanguagesEnum) === language
  );
};

export const getRefetchModelQueries = (id: string) => [
  { query: GetApplicationMainModelDocument, variables: { id } }
];

export const getTextHelper = (title: string) => {
  const isTitleOverflow = title.length >= maxTitleSymbols;
  if (isTitleOverflow) { return `Для повного відображення назви контенту у додатку, рекомендована кількість символів до ${maxTitleSymbols}` };
};

export const isRequiredFieldEmpty = (value: string | null | []) => { 
  return Array.isArray(value) ? !value.length : !value;
}; 

export const validateInputs = (model: ApplicationMainModel, language: LanguagesEnum) => {
  const invalidCoords = model?.lat && model?.longitude && !coordsCheckHandler(`${model?.lat}, ${model?.longitude}`);
  let isEmptyFields = false;

  for (const field of requiredFields) {
    if (isRequiredFieldEmpty(model[field])) {
      mobileAppModel.setInputErrors(field, true);
      isEmptyFields = true;
    }
  }

  if (!language) {
    mobileAppModel.setInputErrors('language', true);
    isEmptyFields = true;
  }

  if (isEmptyFields) {
    mobileAppModel.setError(true, `Заполните все обязательные поля`);
    return false;
  }

  if (invalidCoords) {
    mobileAppModel.setError(true, 'Неверные координаты');
    return false;
  };

  return true;
};

export const getFieldsToUpdate = (fields:string[], currentModel:ApplicationMainModel) => {
  const fieldsToUpdate = fields
    .filter(key => key in currentModel)
    .reduce((field, key) => ({ ...field, [key]: currentModel[key] }), {});
  
  return fieldsToUpdate;
};

export const getEmbedUrl = (videoID: string) => {
  return `https://www.youtube.com/embed/${videoID}`;
};

export const imageValidation = (file: File) => {
  const isInvalidExtension = invalidFileExtensions.some(ext => file.name.toLowerCase().endsWith(ext));
  const isImageFormat = validImageTypes.includes(file.type);
  const isImageSize = file.size < maxImageSize;
  
  const errorMessage = !isImageFormat || isInvalidExtension
    ? "Неправильний формат зображення. Використовуйте PNG або JPEG"
    : "Неправильний розмір зображення. Максимальний розмір – 10 МБ";

  const isValidImage = isImageFormat && isImageSize;

  return { isValidImage, isInvalidExtension, errorMessage };
};

export const getYoutubeVideoId = (url: string): string | null => {
  const regExp = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|&v=)([^#&?]*).*/;
  const match = url.match(regExp);
  const videoIdGroupIndex = 2;
  const videoIdLength = 11;
  
  return match && match[videoIdGroupIndex].length === videoIdLength ? match[videoIdGroupIndex] : null;
};

export const checkedVrBundle = (bundles: ApplicationMainModelFile[]) => {
  return bundles?.some((item) => item.type === ApplicationMainModelFileTypeEnum.Vr);
};

export const checkedOtherBundle = (bundles: ApplicationMainModelFile[]) => {
  return bundles?.some((item) => item.type !== ApplicationMainModelFileTypeEnum.Vr);
};

export const getBundleStatus = (bundles: ApplicationMainModelFile[], name: BundleNames, type: BundleMode) => {
  const isVrCurrentBundle = name === BundleNames.Vr;
  const isManifestBundleMode = type === BundleMode.Manifest;
  const isVrBundles = checkedVrBundle(bundles);
  const isOtherBundles = checkedOtherBundle(bundles);

  const isDisabledVrBundle = isVrCurrentBundle && isOtherBundles && !isManifestBundleMode;
  const isDisabledOtherBundles = !isVrCurrentBundle && isVrBundles && !isManifestBundleMode;

  return { isDisabledVrBundle, isDisabledOtherBundles };
};

export const mapIds = <T extends { id?: string }>(arr: T[] = []) => { 
  return arr.map((item) => item.id); 
};
